// extracted by mini-css-extract-plugin
module.exports = {"root":"appLayout_root__2X5o0","iconMenu":"appLayout_iconMenu__53Q7Z","siteLayout":"appLayout_siteLayout__3riOF"};